export default {
  current: null,
  props: { },
  resolve: null,
  reject: null,
};
